<template>
  <div class="content">
    <!-- eslint-disable-next-line -->
    <p v-if="!hidebuttons"><a @click="prev"> < Back to All Accounts</a></p>
    <div v-if="reportData.errors">
      Errors:
      <ul>
        <li v-for="(e, idx) in reportData.errors" v-bind:key="idx">
          <strong>{{ e.errorCode }}</strong> - {{ e.message }}
        </li>
      </ul>
    </div>
    <div v-else-if="reportData.statement && !reportData.addressInformation">
      <li v-for="(e, idx) in reportData.statement" v-bind:key="idx">
        <strong>{{ e.statementText }}</strong>
      </li>
    </div>
    <div v-else-if="!reportData.consumerIdentity && reportData.informationalMessage">
      <li v-for="(e, idx) in reportData.informationalMessage" v-bind:key="idx">
        <strong>{{ e.messageText }}</strong>
      </li>
    </div>
    <div v-else>
      <h2>Prequalification</h2>
      <hr />

      <!-- <div class="box">
      <div class="columns is-vcentered" style="text-align: center;">
        <div class="column is-one-third">
          <p class="subtitle" style="font-size: 1rem;">Best Name</p>
          <p class="title title-name">{{nameFormatter(reportData.consumerIdentity.name[0])}}</p>
        </div>
        <div class="column">
          <p class="subtitle" style="font-size: 1rem;">Other Name(s)</p>
          <p class="title title-name">{{otherNames(reportData.consumerIdentity.name)}}</p>
        </div>
      </div>
    </div>-->
      <p class="title">
        {{ nameFormatter(reportData.consumerIdentity.name[0]) }}
      </p>
      <p class="subtitle" style="font-size: 1rem">
        <strong>Other Name(s):</strong>
        <br />
        {{ otherNames(reportData.consumerIdentity.name) }}
      </p>
      <p>Address</p>

      <p
        v-for="(address, idx) in reportData.addressInformation"
        v-bind:key="'address' + idx"
      >
        <strong v-if="idx == 0">
          {{ address.streetPrefix }} {{ address.streetName }}
          {{ address.streetSuffix }}
          <br />
          {{ address.city }}, {{ address.state }} {{ address.zipCode }}
        </strong>
        <span v-else>
          {{ address.streetPrefix }} {{ address.streetName }}
          {{ address.streetSuffix }}
          <br />
          {{ address.city }}, {{ address.state }} {{ address.zipCode }}
        </span>
      </p>

      <div
        v-if="
          reportData.employmentInformation &&
          reportData.employmentInformation.length > 0
        "
      >
        <p class="subtitle" style="font-size: 1rem">
          <strong>Employment Information:</strong>
          <br />
        </p>
        <div class="columns is-multiline">
          <div
            class="column is-one-half"
            v-for="(e, idx) in reportData.employmentInformation"
            v-bind:key="'employment' + idx"
          >
            <div class="box">
              <p>
                <strong>{{ e.name }}</strong>
              </p>
              <p>Reported {{ formatDate(e.firstReportedDate) }}</p>
            </div>
          </div>
        </div>
      </div>
      <h3>Messages</h3>
      <hr />

      <ul>
        <li
          v-for="(message, idx) in reportData.informationalMessage"
          v-bind:key="'message' + idx"
        >
          {{ message.messageNumberDetailed }} {{ message.messageText }}
        </li>
      </ul>
      <h3>Score Summary</h3>
      <hr />
      <div class="columns is-vcentered">
        <div class="column is-one-quarter">
          <div
            class="box"
            style="text-align: center; font-variant-caps: all-petite-caps"
          >
            <p class="title">{{ parseInt(reportData.riskModel[0].score) }}</p>
            <p
              class="subtitle"
              style="
                font-variant-caps: all-small-caps;
                font-size: 0.9rem;
                text-align: center;
                color: grey;
              "
            >
              {{
                translate(
                  reportData.riskModel[0].modelIndicator,
                  "modelIndicator"
                )
              }}
            </p>
          </div>
        </div>
        <div class="column">
          <ul>
            <li
              v-for="(factor, idx) in reportData.riskModel[0].scoreFactors"
              v-bind:key="'scorefactor' + idx"
            >
              <strong>{{ factor.code }}</strong>
              {{ translate(factor.code, "code") }}
            </li>
          </ul>
        </div>
      </div>
      <h3>Profile Summary</h3>
      <hr />
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <div class="tile is-child box" style="text-align: center">
            <p class="title">
              {{ parseInt(profileAttribute("disputedAccountsExcluded")) }}
            </p>
            <p
              class="subtitle"
              style="
                font-variant-caps: all-small-caps;
                font-size: 0.9rem;
                text-align: center;
                color: grey;
              "
            >
              Disputed Accounts
            </p>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child box">
            <div class="columns" style="text-align: center">
              <div class="column">
                <p class="title">
                  {{ parseInt(profileAttribute("delinquencies30Days")) }}
                </p>
                <p class="subtitle" style="font-size: 1rem">30</p>
              </div>
              <div class="column">
                <p class="title">
                  {{ parseInt(profileAttribute("delinquencies60Days")) }}
                </p>
                <p class="subtitle" style="font-size: 1rem">60</p>
              </div>
              <div class="column">
                <p class="title">
                  {{ parseInt(profileAttribute("delinquencies90to180Days")) }}
                </p>
                <p class="subtitle" style="font-size: 1rem">90+</p>
              </div>
              <div class="column">
                <p class="title">
                  {{ parseInt(profileAttribute("derogCounter")) }}
                </p>
                <p class="subtitle" style="font-size: 1rem">DEROG</p>
              </div>
            </div>

            <p
              class="subtitle"
              style="
                font-variant-caps: all-small-caps;
                font-size: 0.9rem;
                text-align: center;
                color: grey;
              "
            >
              Delinquency Counter
            </p>
          </div>
        </div>
      </div>
      <table
        class="table is-fullwidth"
        style="font-variant-caps: all-petite-caps"
      >
        <tbody>
          <tr>
            <td class="title-cell">Public Records:</td>
            <td>{{ parseInt(profileAttribute("publicRecordsCount")) }}</td>
            <td class="title-cell">Past Due Amount:</td>
            <td>${{ numberWithCommas(profileAttribute("pastDueAmount")) }}</td>
            <td class="title-cell">Total Inquiries:</td>
            <td>{{ parseInt(profileAttribute("totalInquiries")) }}</td>
            <td class="title-cell">Satisfactory Accts:</td>
            <td>{{ parseInt(profileAttribute("satisfactoryAccounts")) }}</td>
          </tr>
          <tr>
            <td class="title-cell">Installment Bal:</td>
            <td>
              ${{ numberWithCommas(profileAttribute("installmentBalance")) }}
            </td>
            <td class="title-cell">Monthly Pay:</td>
            <td>${{ numberWithCommas(profileAttribute("monthlyPayment")) }}</td>
            <td class="title-cell">Inquiries (last 6 mo):</td>
            <td>
              {{ parseInt(profileAttribute("inquiriesDuringLast6Months")) }}
            </td>
            <td class="title-cell">Now Delinq/Derog:</td>
            <td>{{ parseInt(profileAttribute("nowDelinquentDerog")) }}</td>
          </tr>
          <tr>
            <td class="title-cell">Real Estate Bal:</td>
            <td>
              ${{ numberWithCommas(profileAttribute("realEstateBalance")) }}
            </td>
            <td class="title-cell">Real Estate Pay:</td>
            <td>
              ${{ numberWithCommas(profileAttribute("realEstatePayment")) }}
            </td>
            <td class="title-cell">Total Tradelines:</td>
            <td>{{ parseInt(profileAttribute("totalTradeItems")) }}</td>
            <td class="title-cell">Was Delinq/Derog:</td>
            <td>{{ parseInt(profileAttribute("wasDelinquentDerog")) }}</td>
          </tr>
          <tr>
            <td class="title-cell">Revolving Bal:</td>
            <td>
              ${{ numberWithCommas(profileAttribute("revolvingBalance")) }}
            </td>
            <td class="title-cell">Revolving Avail:</td>
            <td>
              {{ parseInt(profileAttribute("revolvingAvailablePercent")) }}%
            </td>
            <td class="title-cell">Paid Accounts:</td>
            <td>{{ parseInt(profileAttribute("paidAccounts")) }}</td>
            <td class="title-cell">Oldest Tradeline:</td>
            <td>{{ formatDate(profileAttribute("oldestTradeDate")) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="reportData.publicRecord && reportData.publicRecord.length > 0">
        <h3>Public Records</h3>
        <hr />
        <div
          v-for="(e, idx) in reportData.publicRecord"
          v-bind:key="'publicrecord' + idx"
        >
          <div class="box">
            <p>
              <strong>{{ e.courtName }}</strong> / {{ e.courtCode }}
            </p>

            <div class="columns">
              <div class="column is-one-half">
                <table class="table is-fullwidth">
                  <tbody>
                    <tr>
                      <td class="title-cell">Type/Status:</td>
                      <td>{{ translate(e.status, "prstatus") }}</td>
                    </tr>
                    <tr>
                      <td class="title-cell">Filing Date:</td>
                      <td>{{ formatDate(e.filingDate) }}</td>
                    </tr>
                    <tr>
                      <td class="title-cell">Status Date:</td>
                      <td>{{ formatDate(e.statusDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="column is-one-half">
                <table class="table is-fullwidth">
                  <tbody>
                    <tr>
                      <td class="title-cell">Amount:</td>
                      <td>{{ e.amount }}</td>
                    </tr>
                    <tr>
                      <td class="title-cell">Responsibility:</td>
                      <td>{{ translate(e.ecoa, "ecoa") }}</td>
                    </tr>
                    <tr>
                      <td class="title-cell">Certificate ID:</td>
                      <td>{{ e.referenceNumber }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>Inquiries</h3>
      <hr />
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Date</th>
            <th>Subscriber</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Terms</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(inq, idx) in reportData.inquiry"
            v-bind:key="'inquiry' + idx"
          >
            <td>{{ formatDate(inq.date) }}</td>
            <td>
              {{ inq.subscriberName }}/{{ inq.subscriberCode }}/{{ inq.kob }}
            </td>
            <td>{{ inq.amount }}</td>
            <td>{{ translate(inq.type, "type") }}</td>
            <td>{{ inq.terms }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Creditors</h3>
      <hr />
      <div
        v-for="(tl, idx) in creditors"
        v-bind:key="'creditor' + idx"
        style
        class="box creditor"
      >
        <p
          style="
            background: #f8fbff;
            text-align: center;
            margin: -10px;
            margin-bottom: 5px;
            padding: 5px;
          "
        >
          <strong
            >{{ tl.subscriberName }} / {{ tl.subscriberCode }} / {{ tl.kob }} -
            {{ translate(tl.kob, "kob") }}</strong
          >
        </p>
        <div v-if="tl.terms == 'REV'">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Open Date</th>
                <th>Credit Limit</th>
                <th>High Balance</th>
                <th>Status Date</th>
                <th>Past Due</th>
                <th>Last Paid Date</th>
                <th>Scheduled Payment</th>
                <th>Balance Date</th>
                <th>Current Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ formatDate(tl.openDate) }}</td>
                <td>
                  ${{
                    numberWithCommas(tl.enhancedPaymentData.creditLimitAmount)
                  }}
                </td>
                <td>
                  ${{
                    numberWithCommas(tl.enhancedPaymentData.highBalanceAmount)
                  }}
                </td>
                <td>{{ formatDate(tl.statusDate) }}</td>
                <td>
                  <span v-if="tl.amountPastDue > 0"
                    >${{ numberWithCommas(tl.amountPastDue) }}</span
                  >
                </td>
                <td>{{ formatDate(tl.lastPaymentDate) }}</td>
                <td>
                  <span v-if="tl.monthlyPaymentAmount > 0"
                    >${{ numberWithCommas(tl.monthlyPaymentAmount) }}</span
                  >
                </td>
                <td>{{ formatDate(tl.balanceDate) }}</td>
                <td>${{ numberWithCommas(tl.balanceAmount) }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table is-fullwidth">
            <tbody>
              <tr>
                <td class="title-cell">Account Condition:</td>
                <td>
                  {{
                    translate(
                      tl.enhancedPaymentData.enhancedAccountCondition,
                      "enhancedAccountCondition"
                    )
                  }}
                </td>
                <td class="title-cell">Account #:</td>
                <td>-</td>
                <td class="title-cell">Worst Delinquency:</td>
                <td>
                  {{
                    translate(
                      tl.enhancedPaymentData.maxDelinquencyCode,
                      "maxDelinquencyCode"
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="title-cell">Payment Status:</td>
                <td>{{ translate(tl.status, "enhancedAccountCondition") }}</td>
                <td class="title-cell">Responsibility:</td>
                <td>{{ translate(tl.ecoa, "ecoa") }}</td>
                <td class="title-cell">Worst Delinq Date:</td>
                <td>{{ formatDate(tl.maxDelinquencyDate) }}</td>
              </tr>
              <tr>
                <td class="title-cell">Account Type:</td>
                <td>{{ translate(tl.accountType, "type") }}</td>
                <td class="title-cell">Account Terms:</td>
                <td>Revolving</td>
                <td class="title-cell">Months Reviewed:</td>
                <td>{{ tl.monthsHistory }}</td>
              </tr>
            </tbody>
          </table>
          <div class="columns is-vcentered">
            <div class="column">
              <div class="box">
                <ExpPaymentHistory
                  :history="tl.paymentHistory"
                  :balanceDate="tl.balanceDate"
                />
                <p
                  class="subtitle"
                  style="
                    font-variant-caps: all-small-caps;
                    font-size: 0.9rem;
                    text-align: center;
                    color: grey;
                  "
                >
                  Payment History
                </p>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="columns" style="text-align: center">
                  <div class="column">
                    <p class="title">{{ parseInt(tl.delinquencies30Days) }}</p>
                    <p class="subtitle" style="font-size: 1rem">30</p>
                  </div>
                  <div class="column">
                    <p class="title">{{ parseInt(tl.delinquencies60Days) }}</p>
                    <p class="subtitle" style="font-size: 1rem">60</p>
                  </div>
                  <div class="column">
                    <p class="title">
                      {{ parseInt(tl.delinquencies90to180Days) }}
                    </p>
                    <p class="subtitle" style="font-size: 1rem">90+</p>
                  </div>
                  <div class="column">
                    <p class="title">{{ parseInt(tl.derogCounter) }}</p>
                    <p class="subtitle" style="font-size: 1rem">DEROG</p>
                  </div>
                </div>

                <p
                  class="subtitle"
                  style="
                    font-variant-caps: all-small-caps;
                    font-size: 0.9rem;
                    text-align: center;
                    color: grey;
                  "
                >
                  Delinquency Counter
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Open Date</th>
                <th>Original Amount</th>
                <th>Status Date</th>
                <th>Past Due</th>
                <th>Last Paid Date</th>
                <th>Balance Date</th>
                <th>Current Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ formatDate(tl.openDate) }}</td>
                <td>
                  ${{
                    numberWithCommas(tl.enhancedPaymentData.originalLoanAmount)
                  }}
                </td>
                <td>{{ formatDate(tl.statusDate) }}</td>
                <td>
                  <span v-if="tl.amountPastDue > 0"
                    >${{ numberWithCommas(tl.amountPastDue) }}</span
                  >
                </td>
                <td>{{ formatDate(tl.lastPaymentDate) }}</td>
                <td>{{ formatDate(tl.balanceDate) }}</td>
                <td>${{ numberWithCommas(tl.balanceAmount) }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table is-fullwidth">
            <tbody>
              <tr>
                <td class="title-cell">Account Condition:</td>
                <td>
                  {{
                    translate(
                      tl.enhancedPaymentData.enhancedAccountCondition,
                      "enhancedAccountCondition"
                    )
                  }}
                </td>
                <td class="title-cell">Account #:</td>
                <td>-</td>
                <td class="title-cell">Worst Delinquency:</td>
                <td>
                  {{
                    translate(
                      tl.enhancedPaymentData.maxDelinquencyCode,
                      "maxDelinquencyCode"
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="title-cell">Payment Status:</td>
                <td>{{ translate(tl.status, "enhancedAccountCondition") }}</td>
                <td class="title-cell">Responsibility:</td>
                <td>{{ translate(tl.ecoa, "ecoa") }}</td>
                <td class="title-cell">Worst Delinq Date:</td>
                <td>{{ formatDate(tl.maxDelinquencyDate) }}</td>
              </tr>
              <tr>
                <td class="title-cell">Account Type:</td>
                <td>{{ translate(tl.accountType, "type") }}</td>
                <td class="title-cell">Account Terms:</td>
                <td>{{ parseInt(tl.terms) }} Months</td>
                <td class="title-cell">Months Reviewed:</td>
                <td>{{ tl.monthsHistory }}</td>
              </tr>
            </tbody>
          </table>
          <div class="columns is-vcentered">
            <div class="column">
              <div class="box">
                <ExpPaymentHistory
                  :history="tl.paymentHistory"
                  :balanceDate="tl.balanceDate"
                />
                <p
                  class="subtitle"
                  style="
                    font-variant-caps: all-small-caps;
                    font-size: 0.9rem;
                    text-align: center;
                    color: grey;
                  "
                >
                  Payment History
                </p>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="columns" style="text-align: center">
                  <div class="column">
                    <p class="title">{{ parseInt(tl.delinquencies30Days) }}</p>
                    <p class="subtitle" style="font-size: 1rem">30</p>
                  </div>
                  <div class="column">
                    <p class="title">{{ parseInt(tl.delinquencies60Days) }}</p>
                    <p class="subtitle" style="font-size: 1rem">60</p>
                  </div>
                  <div class="column">
                    <p class="title">
                      {{ parseInt(tl.delinquencies90to180Days) }}
                    </p>
                    <p class="subtitle" style="font-size: 1rem">90+</p>
                  </div>
                  <div class="column">
                    <p class="title">{{ parseInt(tl.derogCounter) }}</p>
                    <p class="subtitle" style="font-size: 1rem">DEROG</p>
                  </div>
                </div>

                <p
                  class="subtitle"
                  style="
                    font-variant-caps: all-small-caps;
                    font-size: 0.9rem;
                    text-align: center;
                    color: grey;
                  "
                >
                  Delinquency Counter
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Input from "@/components/shared/Input";
import ExpPaymentHistory from "@/components/shared/ExpPaymentHistory";
import moment from "moment";
export default {
  name: "Report",
  components: {
    ExpPaymentHistory,
  },
  props: {
    report: String,
    hidebuttons: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    reportData: function () {
      let r = JSON.parse(this.report);
      console.log(r);
      return r["creditProfile"] ? r["creditProfile"][0] : r;
    },
    creditors: function () {
      function compare(a, b) {
        if (a.terms < b.terms) return -1;
        if (a.terms > b.terms) return 1;
        return 0;
      }
      var arr = this.reportData.tradeline;

      arr = arr.sort(compare);

      return arr;
    },
  },
  methods: {
    profileAttribute(id) {
      if (!this.reportData || !this.reportData.summaries) {
        return 0;
      }
      for (var i = 0; i < this.reportData.summaries[0].attributes.length; i++) {
        let attr = this.reportData.summaries[0].attributes[i];
        if (attr.id == id) {
          return attr.value;
        }
      }

      return null;
    },
    nameFormatter(name) {
      //name is a name object
      var n = name.firstName;
      if (name.middleName) {
        n += " " + name.middleName;
      }
      if (name.surname) {
        n += " " + name.surname;
      }
      if (name.generationCode) {
        n += " " + name.generationCode;
      }
      return n;
    },
    otherNames(names) {
      var self = this;
      if (names.length < 2) {
        return "-";
      } else {
        let str = "";
        names.forEach((name) => {
          str += self.nameFormatter(name) + "; ";
        });
        return str;
      }
    },
    translate(val, field) {
      switch (field) {
        case "prstatus":
          switch (val) {
            case "13":
              return "Bankruptcy Chapter 13-petition filed";
              break;
            case "15":
              return "Bankruptcy chapter 7-discharged";
              break;
            case "16":
              return "Bankruptcy chapter 13-dismissed";
              break;
            case "17":
              return "Bankruptcy chapter 13-discharged";
              break;
            case "22":
              return "Bankruptcy chapter 11-dismissed";
              break;
            case "23":
              return "Bankruptcy chapter 7-petition filed";
              break;
            case "24":
              return "Bankruptcy chapter 7-dismissed";
              break;
            case "25":
              return "Bankruptcy chapter 11-petition filed";
              break;
            case "26":
              return "Bankruptcy chapter 11-discharged";
              break;
            case "27":
              return "Bankruptcy chapter 12-petition filed";
              break;
            case "28":
              return "Bankruptcy chapter 12-discharged";
              break;
            case "29":
              return "Bankruptcy chapter 12-dismissed";
              break;
          }
          break;
        case "kob":
          switch (val) {
            case "AC":
              return "Auto Leasing ";
              break;
            case "AB":
              return "Auto Rental";
              break;
            case "AF":
              return "Farm Implement Dealers ";
              break;
            case "AL":
              return "Truck Dealers";
              break;
            case "AN":
              return "Automobile Dealers, New ";
              break;
            case "AP":
              return "Automotive Parts ";
              break;
            case "AR":
              return "Auto Repair, Body Shops ";
              break;
            case "AS":
              return "Service Stations";
              break;
            case "AT":
              return "TBA Stores, Tire Dealers";
              break;
            case "AU":
              return "Automobile Dealers, Used";
              break;
            case "AZ":
              return "Automotive – Non-Specific";
              break;
            case "BB":
              return "All Banks – Non-Specific";
              break;
            case "BC":
              return "Bank Credit Cards";
              break;
            case "BI":
              return "Bank - Installment Loans";
              break;
            case "BM":
              return "Bank - Mortgage Department";
              break;
            case "BN":
              return "Industrial Banks";
              break;
            case "BO":
              return "Co-op Banks";
              break;
            case "BS":
              return "Savings Banks";
              break;
            case "CG":
              return "General Clothing Store";
              break;
            case "CS":
              return "Specialty Clothing Store";
              break;
            case "CZ":
              return "Clothing – Non-Specific";
              break;
            case "DC":
              return "Complete Department Stores";
              break;
            case "DV":
              return "Variety Stores";
              break;
            case "DZ":
              return "Department And Variety Stores – Non-Specific";
              break;
            case "EB":
              return "Business Education ";
              break;
            case "EC":
              return "Colleges";
              break;
            case "EL":
              return "Student Loans";
              break;
            case "ET":
              return "Technical Education";
              break;
            case "EU":
              return "Universities";
              break;
            case "EV":
              return "Vocational And Trade Schools";
              break;
            case "EZ":
              return "Education – Non-Specific";
              break;
            case "FA":
              return "Automobile Financing Company";
              break;
            case "FB":
              return "Mortgage Brokers";
              break;
            case "FC":
              return "Credit Unions";
              break;
            case "FD":
              return "Bail Bonds";
              break;
            case "FF":
              return "Sales Financing Company";
              break;
            case "FI":
              return "Investment Firms";
              break;
            case "FL":
              return "Savings And Loans - Mortgage";
              break;
            case "FM":
              return "Mortgage Companies ";
              break;
            case "FP":
              return "Personal Loan Companies";
              break;
            case "FR":
              return "Mortgage Reporters";
              break;
            case "FS":
              return "Savings And Loan Companies";
              break;
            case "FT":
              return "Investment Securities";
              break;
            case "FU":
              return "Bulk Purchase Finance";
              break;
            case "FW":
              return "Bulk Purchase Finance – General Processors";
              break;
            case "FY":
              return "Misc Loan Broker";
              break;
            case "FZ":
              return "Finance Companies – Non-Specific";
              break;
            case "GD":
              return "Dairies";
              break;
            case "GN":
              return "Neighborhood Grocers";
              break;
            case "GS":
              return "Supermarkets";
              break;
            case "GZ":
              return "Groceries – Non-Specific";
              break;
            case "HA":
              return "Appliance Sales And Service";
              break;
            case "HC":
              return "Carpets And Flooring";
              break;
            case "HD":
              return "Interior Decorators/Design";
              break;
            case "HF":
              return "Home Furnishings Stores";
              break;
            case "HM":
              return "Music And Record Stores";
              break;
            case "HR":
              return "Furniture Rentals";
              break;
            case "HT":
              return "Television And Radio Sales And Service";
              break;
            case "HZ":
              return "Home Furnishings – Non-Specific";
              break;
            case "IG":
              return "General Insurance";
              break;
            case "IL":
              return "Life Insurance";
              break;
            case "IZ":
              return "Insurance – Non-Specific";
              break;
            case "JA":
              return "Jewelers";
              break;
            case "JC":
              return "Cameras";
              break;
            case "JP":
              return "Computer Sales and Services";
              break;
            case "JV":
              return "Video Tape Rental and Sales";
              break;
            case "JZ":
              return "Jewelry, Cameras & Computers – Non-Specific";
              break;
            case "KG":
              return "General Contractors";
              break;
            case "KI":
              return "Home Improvement Contractor";
              break;
            case "KS":
              return "Sub-Contractors ";
              break;
            case "KZ":
              return "Contractors – Non-Specific";
              break;
            case "LA":
              return "Air Conditioning/Heating/Plumbing/Electrical Sales ";
              break;
            case "LF":
              return "Fixture Suppliers ";
              break;
            case "LH":
              return "Hardware Stores ";
              break;
            case "LP":
              return "Paint, Glass, Wallpaper Stores";
              break;
            case "LY":
              return "Lumber Yard";
              break;
            case "LZ":
              return "Lumber/Building Material/Hardware – Non-Specific";
              break;
            case "MA":
              return "Animal Hospitals";
              break;
            case "MB":
              return "Dentists";
              break;
            case "MC":
              return "Chiropractors";
              break;
            case "MD":
              return "Doctors";
              break;
            case "MF":
              return "Funeral Homes";
              break;
            case "MG":
              return "Medical Group";
              break;
            case "MH":
              return "Hospitals And Clinics ";
              break;
            case "MM":
              return "Cemeteries";
              break;
            case "MO":
              return "Osteopaths";
              break;
            case "MP":
              return "Pharmacies And Drug Stores";
              break;
            case "MS":
              return "Optometrists And Optical Stores";
              break;
            case "MV":
              return "Veterinarians";
              break;
            case "MZ":
              return "Medical And Health Related – Non-Specific";
              break;
            case "NA":
              return "Airlines ";
              break;
            case "ND":
              return "Credit Card - Dept. Store ";
              break;
            case "NF":
              return "Credit Card - Finance Company";
              break;
            case "NS":
              return "Credit Card - Savings and Loan ";
              break;
            case "NU":
              return "Credit Card - Credit Union";
              break;
            case "NZ":
              return "National Credit Card/Airlines – Non-Specific";
              break;
            case "OC":
              return "Oil Company Credit Cards";
              break;
            case "OZ":
              return "Oil Companies – Non-Specific";
              break;
            case "PA":
              return "Accountants And Related Services ";
              break;
            case "PB":
              return "Barber And Beauty Shops";
              break;
            case "PC":
              return "Equipment Leasing";
              break;
            case "PD":
              return "Dry Cleaning/Laundry/Related";
              break;
            case "PE":
              return "Engineering/All Kinds";
              break;
            case "PF":
              return "Florists 3 Retail PG Photographers";
              break;
            case "PH":
              return "Health And Fitness Clubs";
              break;
            case "PI":
              return "Detective Service";
              break;
            case "PL":
              return "Legal And Related ServicesPM Check Cashing Service";
              break;
            case "PN":
              return "Restaurants/Concessions";
              break;
            case "PP":
              return "Pest Control";
              break;
            case "PR":
              return "Country Clubs";
              break;
            case "PS":
              return "Employment Screening";
              break;
            case "PT":
              return "Consumer Credit Counseling Service";
              break;
            case "PX":
              return "Prequalification Sservices";
              break;
            case "PY":
              return "Internet Prequalification Services";
              break;
            case "PZ":
              return "Personal Services/Non-Medical – Non-Specific";
              break;
            case "QZ":
              return "Mail Order Houses – Non-Specific 3 Retail RA Apartments";
              break;
            case "RC":
              return "Office Leasing";
              break;
            case "RD":
              return "Mobile Home Dealers";
              break;
            case "RE":
              return "Real Estate Sales And Rentals";
              break;
            case "RH":
              return "Hotels";
              break;
            case "RM":
              return "Motels";
              break;
            case "RP":
              return "Mobile Home Parks";
              break;
            case "RR":
              return "Property And Property Management Companies";
              break;
            case "RZ":
              return "Real Estate/Public Accommodations – Non-Specific";
              break;
            case "SA":
              return "Aircraft Sales And Service";
              break;
            case "SB":
              return "Boats And Marinas Sales And Service";
              break;
            case "SM":
              return "Motorcycles And Bicycles Sales";
              break;
            case "SZ":
              return "Sporting Goods – Non-Specific";
              break;
            case "TC":
              return "Farm Chemical And Fertilizer Stores";
              break;
            case "TF":
              return "Feed And Feed Stores 3 Retail TN Nursery And Landscaping";
              break;
            case "TZ":
              return "Farm And Garden Suppliers – Non-Specific";
              break;
            case "UA":
              return "Water Utilities/Bottled Water";
              break;
            case "UC":
              return "Cable TV Providers";
              break;
            case "UD":
              return "Garbage And Rubbish Disposal";
              break;
            case "UE":
              return "Electric Light And Power Company";
              break;
            case "UF":
              return "Fuel Oil Distributors";
              break;
            case "UG":
              return "Gas Company, Natural And Bottled";
              break;
            case "UH":
              return "Coal/Wood Suppliers";
              break;
            case "UL":
              return "Long Distance Telephone Service Providers";
              break;
            case "UO":
              return "Online/Internet Access Providers";
              break;
            case "UP":
              return "Paging Companies";
              break;
            case "UR":
              return "Waste Recycling/Hazardous Waste Handlers";
              break;
            case "US":
              return "Satellite TV/Direct Broadcast Satellite Providers";
              break;
            case "UT":
              return "Telephone Companies";
              break;
            case "UV":
              return "Home Security Company";
              break;
            case "UW":
              return "Wireless Telephone Service Providers";
              break;
            case "UZ":
              return "Utilities And Fuel – Non-Specific";
              break;
            case "VC":
              return "City And County Government";
              break;
            case "VF":
              return "Federal Government";
              break;
            case "VK":
              return "Child Support   VL Law Enforcement 0 Public Record VS State Government";
              break;
            case "VX":
              return "Court Codes 0 Public Record VZ Government – Non-Specific";
              break;
            case "WA":
              return "Automotive Supplies";
              break;
            case "WB":
              return "Building Supplies/Hardware";
              break;
            case "WC":
              return "Clothing And Dry Goods";
              break;
            case "WD":
              return "Drugs, Chemicals And Related Goods";
              break;
            case "WG":
              return "Grocery and Related Products";
              break;
            case "WH":
              return "Home Furnishings";
              break;
            case "WM":
              return "Machinery, Equipment Supplies";
              break;
            case "WP":
              return "Credit Card Processors";
              break;
            case "WZ":
              return "Wholesale – Non-Specific";
              break;
            case "XA":
              return "Advertising Agencies";
              break;
            case "XD":
              return "Direct Mail List Services";
              break;
            case "XL":
              return "List Processing Vendors";
              break;
            case "XM":
              return "Media";
              break;
            case "XZ":
              return "Miscellaneous Advertising";
              break;
            case "YA":
              return "Collection Department - ACB Credit Bureau";
              break;
            case "YB":
              return "Collection Department - Bank ";
              break;
            case "YC":
              return "Other Collection Agencies";
              break;
            case "YD":
              return "Collection Department - Department Store ";
              break;
            case "YF":
              return "Collection Department - Loan Company ";
              break;
            case "YL":
              return "Collections Attorney";
              break;
            case "YR":
              return "Repo Company";
              break;
            case "YZ":
              return "Collections – Non-Specific";
              break;
            case "ZA":
              return "Auto Reseller";
              break;
            case "ZB":
              return "Credit Report Brokers";
              break;
            case "ZC":
              return "Credit Bureaus";
              break;
            case "ZD":
              return "Reseller - Direct to Customer";
              break;
            case "ZE":
              return "Employment Reseller";
              break;
            case "ZF":
              return "Finance Reseller";
              break;
            case "ZG":
              return "IRSG Reseller 5A";
              break;
            case "ZH":
              return "IRSG Reseller 5B";
              break;
            case "ZI":
              return "Insurance Reseller";
              break;
            case "ZL":
              return "Leasing and Rental Reseller";
              break;
            case "ZM":
              return "Manufacturing";
              break;
            case "ZP":
              return "Personal Service Reseller";
              break;
            case "ZR":
              return "Retail, Not Elsewhere Classified 3 Retail ZS Services, Not Elsewhere Classified";
              break;
            case "ZT":
              return "Tenant Screeners (Reseller)";
              break;
            case "ZW":
              return "Wholesale, Not Elsewhere Classified";
              break;
            case "ZY":
              return "Collection Reseller";
              break;
            case "ZZ":
              return "All others not classified elsewhere 9 Service & Professional";
              break;
          }
          break;
        case "enhancedAccountCondition":
          switch (val) {
            case "00":
              return "No condition/status";
              break;
            case "03":
              return "Credit card lost or stolen";
              break;
            case "05":
              return "Account transferred to another office";
              break;
            case "07":
              return "Current account/was delinquent 60 days past due date two times";
              break;
            case "08":
              return "Current account/was delinquent 60 days past due date three times";
              break;
            case "09":
              return "Current account/was delinquent 60 days past due date four or more times";
              break;
            case "10":
              return "Account renewed or refinanced";
              break;
            case "11":
              return "This is an account in good standing";
              break;
            case "12":
              return "Account/paid satisfactorily";
              break;
            case "13":
              return "Paid account/zero balance";
              break;
            case "14":
              return "Current account/was 90 days past due date two times";
              break;
            case "15":
              return "Current account/was 90 days past due date 3 or more times";
              break;
            case "16":
              return "Current account/was 120 days past due date 2 or more times";
              break;
            case "17":
              return "Current account/was 150 days past due date 2 or more times";
              break;
            case "20":
              return "Credit line closed/reason unknown or by consumer request/there may be balance due";
              break;
            case "21":
              return "Consumer reported as deceased";
              break;
            case "22":
              return "Account 60 days past due date 2 times";
              break;
            case "23":
              return "Account 60 days past due date 3 times";
              break;
            case "24":
              return "Account 60 days past due date 4 or more times";
              break;
            case "25":
              return "Account 90 days past due date 2 times";
              break;
            case "26":
              return "Account 90 days past due date 3 or more times";
              break;
            case "27":
              return "Account 120 days past due date 2 or more times";
              break;
            case "28":
              return "Account 150 days past due date 2 or more times";
              break;
            case "29":
              return "Account 90 days past due date/ was 120 days or more past due date";
              break;
            case "31":
              return "Current account/was 30 days past due date";
              break;
            case "32":
              return "Current account/was 30 days past due date two times";
              break;
            case "33":
              return "Current account/was 30 days past due date three times";
              break;
            case "34":
              return "Current account/was 30 days past due date four times";
              break;
            case "35":
              return "Current account/was 30 days past due date five times";
              break;
            case "36":
              return "Current account/was 30 days past due date six times or more";
              break;
            case "37":
              return "Current account/was delinquent 60 days past due date";
              break;
            case "38":
              return "Current account/was delinquent 90 days past due date";
              break;
            case "39":
              return "Current account/was delinquent 120 days past due date";
              break;
            case "40":
              return "Current account/was delinquent 150 days past due date";
              break;
            case "41":
              return "Current account/was delinquent 180 days or more past due date";
              break;
            case "42":
              return "Account now redeemed/was a repossession";
              break;
            case "43":
              return "Current account/was a collection account, insurance claim or government claim or terminated for default";
              break;
            case "45":
              return "Current account/foreclosure was started";
              break;
            case "51":
              return "Paid account/was 30 days past due date";
              break;
            case "52":
              return "Paid account/was 30 days past due date two or three times";
              break;
            case "53":
              return "Paid account/was 30 days past due date four times";
              break;
            case "54":
              return "Paid account/was 30 days past due date five times";
              break;
            case "55":
              return "Paid account/was 30 days past due date six times or more";
              break;
            case "56":
              return "Paid account/was delinquent 60 days past due date";
              break;
            case "57":
              return "Paid account/was delinquent 90 days past due date";
              break;
            case "58":
              return "Paid account/was delinquent 120 days past due date";
              break;
            case "59":
              return "Paid account/was delinquent 150 days past due date";
              break;
            case "60":
              return "Paid account/was delinquent 180 days or more past due date";
              break;
            case "61":
              return "Paid account/was a voluntary surrender";
              break;
            case "62":
              return "Paid account/was a collection account, insurance claim or government claim or was terminated for default";
              break;
            case "63":
              return "Paid account/was a repossession";
              break;
            case "64":
              return "Paid account/was a charge-off";
              break;
            case "65":
              return "Paid account, foreclosure was started";
              break;
            case "66":
              return "Credit grantor paid by company who originally sold the merchandise";
              break;
            case "67":
              return "Debt included in or discharged through Bankruptcy Chapter 7, 11, or 12";
              break;
            case "68":
              return "Account legally paid in full for less than the full balance";
              break;
            case "69":
              return "Debt included in or discharged through Bankruptcy Chapter 13";
              break;
            case "71":
              return "Account 30 days past due date";
              break;
            case "72":
              return "Account 30 days past due date two times";
              break;
            case "73":
              return "Account 30 days past due date three times";
              break;
            case "74":
              return "Account 30 days past due date four times";
              break;
            case "75":
              return "Account 30 days past due date five times";
              break;
            case "76":
              return "Account 30 days past due date six times or more";
              break;
            case "77":
              return "Account was delinquent 60 days past due date/now 30 days past due date";
              break;
            case "78":
              return "Account delinquent 60 days past due date";
              break;
            case "79":
              return "Account was delinquent 90 days past due date/now 30 or 60 days past due date";
              break;
            case "80":
              return "Account delinquent 90 days past due date";
              break;
            case "81":
              return "Account was delinquent 120 days or more past due date/now 30, 60, or 90 days past due date";
              break;
            case "82":
              return "Account delinquent 120 days past due date";
              break;
            case "83":
              return "Account delinquent 150 days past due date";
              break;
            case "84":
              return "Account delinquent 180 days past due date";
              break;
            case "85":
              return "Credit Grantor could not locate consumer/consumer now located";
              break;
            case "86":
              return "Now paying/was a charge-off";
              break;
            case "87":
              return "Foreclosure proceeding started";
              break;
            case "88":
              return "Claim filed with government for insured portion of balance on loan";
              break;
            case "89":
              return "Credit grantor received deed for collateral in lieu of foreclosure on a defaulted mortgage";
              break;
            case "90":
              return "Credit line closed/not paying as agreed";
              break;
            case "91":
              return "Early termination by default of original terms of lease or sales contract";
              break;
            case "92":
              return "Claim filed for insured portion of balance";
              break;
            case "93":
              return "Account seriously past due date/account assigned to attorney, collection agency, or credit grantor's internal collection department";
              break;
            case "94":
              return "Credit Grantor reclaimed collateral to settle defaulted mortgage";
              break;
            case "95":
              return "Voluntary surrender";
              break;
            case "96":
              return "Merchandise was taken back by credit grantor; there may be a balance due";
              break;
            case "97":
              return "Unpaid balance reported as a loss by credit grantor";
              break;
            case "98":
              return "Credit grantor cannot locate consumer";
              break;
            case "A1":
              return "Open account";
              break;
            case "A2":
              return "Paid account/zero balance";
              break;
            case "A3":
              return "Closed account";
              break;
            case "A4":
              return "Inactive account";
              break;
          }
          break;
        case "maxDelinquencyCode":
          switch (val) {
            case "0":
              return "Current with zero balance - update received";
              break;
            case "1":
              return "30 days delinquent ";
              break;
            case "2":
              return "60 days delinquent ";
              break;
            case "3":
              return "90 days delinquent ";
              break;
            case "4":
              return "120 days delinquent ";
              break;
            case "5":
              return "150 days delinquent ";
              break;
            case "6":
              return "180 days delinquent ";
              break;
            case "7":
              return "Bankruptcy Chapter 13 Petitioned, or Discharged and Bankruptcy Chapter 13 Reaffirmation of Debt Rescinded";
              break;
            case "8":
              return "Foreclosure Proceedings Started, Deed in Lieu ";
              break;
            case "9":
              return "Insurance Claim, Term Default, Government Claim, Paid by Dealer, BK Chapter 7, 11 or 12";
              break;
            case "B":
              return "Account Condition Changed – Payment Code Not Applicable ";
              break;
            case "C":
              return "Current";
              break;
            case "G":
              return "Collection ";
              break;
            case "H":
              return "Foreclosure ";
              break;
            case "J":
              return "Voluntary Surrender ";
              break;
            case "K":
              return "Repossession ";
              break;
            case "L":
              return "Charge Off ";
              break;
            case "N":
              return "Current with zero balance – no update received ";
              break;
            case "-":
              return "No update received";
              break;
          }
          break;

        case "modelIndicator":
          switch (val) {
            case "F":
              return "FICO Score 2";
              break;
          }
          break;
        //inq types
        case "type":
          switch (val) {
            case "00":
              return "Auto Loan";
              break;
            case "01":
              return "Unsecured Loan";
              break;
            case "02":
              return "Secured Loan";
              break;
            case "03":
              return "Partially Secured Loan";
              break;
            case "04":
              return "Home Improvement Loan";
              break;
            case "05":
              return "FHA Home Improvement Loan";
              break;
            case "06":
              return "Installment Sales Contract";
              break;
            case "07":
              return "Charge Account";
              break;
            case "08":
              return "Real Estate Specific Type Unknown";
              break;
            case "09":
              return "Loan Secured By Cosigner";
              break;
            case "0A":
              return "Time Share Loan";
              break;
            case "0C":
              return "Debt Buyer";
              break;
            case "0F":
              return "Construction Loan";
              break;
            case "0G":
              return "Flexible Spending Credit Card";
              break;
            case "10":
              return "Commercial transaction with personal liability, guarantee or written instruction";
              break;
            case "11":
              return "Recreational Merchandise";
              break;
            case "12":
              return "Education Loan";
              break;
            case "13":
              return "Lease";
              break;
            case "14":
              return "Cosigner (Not Borrower)";
              break;
            case "15":
              return "Check Credit Or Line Of Credit";
              break;
            case "16":
              return "FHA Cosigner (Not Borrower)";
              break;
            case "17":
              return "Manufactured Home";
              break;
            case "18":
              return "Credit Card";
              break;
            case "19":
              return "FHA Real Estate Loan";
              break;
            case "1A":
              return "Lender-Placed Insurance";
              break;
            case "1B":
              return "Legitimate Business Purposes";
              break;
            case "1C":
              return "Purchase Of Household Goods";
              break;
            case "20":
              return "Note Loan";
              break;
            case "21":
              return "Note Loan With Cosigner";
              break;
            case "22":
              return "Secured By Household Goods";
              break;
            case "23":
              return "Secured By Household Goods & Other Collateral";
              break;
            case "25":
              return "VA Real Estate Loan";
              break;
            case "26":
              return "Conventional Real Estate Loan, Including Purchase Money First";
              break;
            case "27":
              return "Real Estate Mortgage - With Or Without Other Collateral. Usually A Second Mortgage";
              break;
            case "29":
              return "Rental";
              break;
            case "2A":
              return "Secured Credit Card";
              break;
            case "2C":
              return "Farmer's Home Administration (FMHA)";
              break;
            case "30":
              return "Summary Of Accounts With Same Status";
              break;
            case "31":
              return "Unknown - Credit Extension, Review, Or Collection";
              break;
            case "33*":
              return "Manual Mortgage";
              break;
            case "37":
              return "Combined Credit Plan";
              break;
            case "3A":
              return "Auto Lease";
              break;
            case "3C*":
              return "Licensing - CA And NV Legal Requirement";
              break;
            case "43":
              return "Debit Card";
              break;
            case "47":
              return "Credit Line Secured";
              break;
            case "48":
              return "Collection Department/Agency/Attorney";
              break;
            case "4D":
              return "Telecommunications/Cellular";
              break;
            case "4F":
              return "Tax Collection";
              break;
            case "50":
              return "Family Support";
              break;
            case "5A":
              return "Real Estate-Jr Liens/Non-Purchase Money";
              break;
            case "5B":
              return "Second Mortgage";
              break;
            case "5C*":
              return "Checking Or Savings/Possible Additional Offers";
              break;
            case "65":
              return "Government Unsecured Guaranteed Loan";
              break;
            case "66":
              return "Government Secured Guaranteed Loan";
              break;
            case "67":
              return "Government Unsecured Direct Loan";
              break;
            case "68":
              return "Government Secured Direct Loan";
              break;
            case "69":
              return "Government Grant";
              break;
            case "6A":
              return "Commercial Installment Loan";
              break;
            case "6B":
              return "Commercial Mortgage";
              break;
            case "6C*":
              return "Credit Granting/Possible Additional Offers";
              break;
            case "6D":
              return "Home Equity";
              break;
            case "70":
              return "Government Overpayment";
              break;
            case "71":
              return "Government Fine";
              break;
            case "72":
              return "Government Fee For Service";
              break;
            case "73":
              return "Government Employee Advance";
              break;
            case "74":
              return "Government Miscellaneous Debt";
              break;
            case "77":
              return "Returned Check";
              break;
            case "78":
              return "Installment Loan";
              break;
            case "7A":
              return "Commercial Line Of Credit";
              break;
            case "7B":
              return "Agriculture";
              break;
            case "7C*":
              return "Service Activation/Possible Additional Offers";
              break;
            case "83":
              return "Post Prescreen/Extract Prescreen Inquiry";
              break;
            case "85":
              return "Bi-Monthly Mortgage Paymen t";
              break;
            case "86*":
              return "Automated Mortgage Report";
              break;
            case "87":
              return "Semi-Monthly Mortgage Payment";
              break;
            case "89":
              return "Home Equity Line Of Credit";
              break;
            case "8A":
              return "Business Credit Card";
              break;
            case "8B":
              return "Deposit Related";
              break;
            case "8C*":
              return "Id Profile";
              break;
            case "90":
              return "Medical Debt";
              break;
            case "91":
              return "Debt Consolidation";
              break;
            case "92":
              return "Utility Company";
              break;
            case "93":
              return "Child Support";
              break;
            case "94":
              return "Spouse Support";
              break;
            case "95":
              return "Attorney Fees";
              break;
            case "96*":
              return "Checking Account";
              break;
            case "98*":
              return "Credit Granting";
              break;
            case "9A":
              return "Secured Home Improvement";
              break;
            case "9B":
              return "Business Line - Personally Guaranteed ";
              break;
          }
          break;

        case "ecoa":
          switch (val) {
            case "0":
              return "Undesignated";
              break;
            case "1":
              return "Individual";
              break;
            case "2":
              return "Joint Account";
              break;
            case "3":
              return "Authorized User";
              break;
            case "4":
              return "Joint Account";
              break;
            case "5":
              return "Cosigner";
              break;
            case "6":
              return "On Behalf Of";
              break;
            case "7":
              return "Signer";
              break;
            case "A":
            case "B":
            case "C":
            case "D":
            case "E":
            case "F":
            case "G":
            case "H":
              return "Terminated";
              break;
            case "X":
              return "Deceased";
              break;
          }
          break;

        //Fico scorefactors
        case "code":
          switch (val) {
            case "00":
              return "No Adverse Factor";
              break;
            case "01":
              return "Amount owed on accounts is too high";
              break;
            case "02":
              return "Level of delinquency on accounts";
              break;
            case "03":
              return "Proportion of loan balances to loan amounts is too high";
              break;
            case "04":
              return "Lack of recent installment loan information";
              break;
            case "05":
              return "Too many accounts with balances";
              break;
            case "06":
              return "Too many consumer finance company accounts";
              break;
            case "07":
              return "Account payment history is too new to rate";
              break;
            case "08":
              return "Too many inquiries last 12 months";
              break;
            case "09":
              return "Too many accounts recently opened";
              break;
            case "10":
              return "Proportion of balances to credit limits on bank/national revolving or other revolving accounts is too high";
              break;
            case "11":
              return "Amount owed on revolving accounts is too high";
              break;
            case "12":
              return "Length of time revolving accounts have been established";
              break;
            case "13":
              return "Time since delinquency is too recent or unknown";
              break;
            case "14":
              return "Length of time accounts have been established";
              break;
            case "15":
              return "Lack of recent bank/national revolving information";
              break;
            case "16":
              return "Lack of recent revolving account information";
              break;
            case "17":
              return "No recent non-mortgage balance information";
              break;
            case "18":
              return "Number of accounts with delinquency";
              break;
            case "19":
              return "Date of last inquiry too recent";
              break;
            case "20":
              return "Time since derogatory public record or collection is too short";
              break;
            case "21":
              return "Amount past due on accounts";
              break;
            case "22T":
              return "Serious delinquency, derogatory public record or collection filed";
              break;

            case "23":
              return "Number of bank or national revolving accounts with balances";
              break;
            case "24":
              return "No recent revolving balances";
              break;
            case "25":
              return "Length of time installment loans have been established";
              break;
            case "26":
              return "Number of bank/national revolving or other revolving accounts";
              break;
            case "27":
              return "Too few accounts currently paid as agreed";
              break;
            case "28":
              return "Number of established accounts";
              break;
            case "29":
              return "No recent bank/national revolving balances";
              break;
            case "30":
              return "Time since most recent account opening is too short";
              break;
            case "31":
              return "Amount owed on delinquent accounts";
              break;
            case "36":
              return "Payments due on accounts";
              break;
            case "38":
              return "Serious delinquency, and public record or collection filed";
              break;
            case "39":
              return "Serious delinquency";
              break;
            case "40":
              return "Derogatory public record or collection filed";
              break;
          }
          break;
      }
      return "-";
    },
    formatUnixTS(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l LT");
    },
    formatUnixDate(ts) {
      // console.log("formatting", ts);
      return moment.unix(ts).format("l");
    },
    formatDate(date) {
      // console.log("formatting", ts);
      let d = moment(date, "MMDDYYYY").format("l");
      if (d == "Invalid date") {
        return "-";
      }
      return d;
    },
    numberWithCommas(val, money = true) {
      if (money) val = parseFloat(val).toFixed(2);
      var returnval = null;
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == "NaN") returnval = "0.00";

      return returnval;
    },
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    prev() {
      this.loading = true;
      this.$emit("prev", this.$data);
    },
    scrollY() {
      this.scroll = window.top.scrollY;
      // console.log(this.scroll)
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollY);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollY);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-floating {
  top: 0px;
  transform: scale(0.9) translateY(80px);
  box-shadow: 0px 4px 19px -8px #cbc1c1;
  width: 100%;
}
.header-floating-open {
  top: -15px;
  transform: scale(0.9) translateY(90px);
  box-shadow: 0px 4px 19px -8px #cbc1c1;
  width: 100%;
}
.floating {
  top: 0px;
  transform: translateY(0px) translateX(-10px);
  box-shadow: 0px 4px 19px 0px #cbc1c1;
  width: 100%;
}
.incomplete-row {
  background: #ececec;
  opacity: 0.3;
}
.title-cell {
  /* background: #f0f0f0; */
  background: #f8fbff;
  text-align: right;
}
.creditor {
  padding: 10px;
}
.title-name {
  font-size: 1.2rem;
  margin-top: 0px !important;
  font-weight: 400;
}
</style>
